import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Desktop } from '@phosphor-icons/react';

/**
 * AnimatedLogo Component
 * Author: MCGdev
 * Orange rounded square with white desktop icon and ECG path animation
 * Memoized for better performance
 */

const AnimatedLogo = React.memo(({ className = '' }) => {
  const reduce = useReducedMotion();

  const pathAnim = reduce
    ? { pathLength: 1, opacity: 1 }
    : { pathLength: [0, 1, 0], opacity: [0, 1, 0] };

  const pathTransition = reduce
    ? { duration: 0 }
    : { duration: 2, repeat: Infinity, ease: 'easeInOut', delay: 0.4 };

  return (
    <motion.div className={"flex items-center gap-2 " + className} whileHover={{ scale: 1.03 }}>
      <motion.div
        className="w-12 h-12 bg-gradient-to-br from-orange-400 to-orange-600 rounded-lg flex items-center justify-center relative overflow-hidden"
        aria-hidden
      >
        <Desktop size={28} weight="fill" className="text-white z-10" />

        <svg
          className="absolute inset-0 w-full h-full"
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          aria-label="logo"
        >
          <motion.path
            d="M4 24 L8 24 L10 18 L12 30 L14 12 L16 36 L18 24 L44 24"
            stroke="rgba(255,255,255,0.9)"
            strokeWidth="1.5"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            initial={reduce ? false : { pathLength: 0, opacity: 0 }}
            animate={pathAnim}
            transition={pathTransition}
          />
        </svg>
      </motion.div>
    </motion.div>
  );
});

AnimatedLogo.displayName = 'AnimatedLogo';

export default AnimatedLogo;